<template>
  <b-modal
    ref="self"
    class="card-form-modal"
    :active.sync="active"
    :custom-class="'dialog'"
    :width="600"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    scroll="keep"
    aria-modal>
    <template>
      <validation-observer v-slot="{ handleSubmit }">
        <div class="modern-card modal-card">
          <header class="modern-card__header">Edit customer
            <b-button class="modern-card__close-button" aria-label="close" icon-right="close"
                      @click="cancel" />
          </header>
          <section class="modern-card__body">
            <form class="modern-modal-form">
              <validation-provider v-slot="{ errors }"
                                   name="Company Name"
                                   v-if="!contractor.hasUser"
                                   rules="required|max:240">
                <b-field v-model="fields.companyName"
                         label="Company Name"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]">
                  <b-input v-model.trim="fields.companyName"
                           maxlength="240"
                           style="width: 100%"></b-input>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }"
                                   v-if="!contractor.hasUser"
                                   rules="required|name|max:250">
                <b-field v-model="fields.firstName"
                         label="First Name"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]">
                  <b-input v-model="fields.firstName" maxlength="250"
                           style="width: 100%"></b-input>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }"
                                   v-if="!contractor.hasUser"
                                   rules="required|name|max:250">
                <b-field v-model="fields.lastName"
                         label="Last Name"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]">
                  <b-input v-model="fields.lastName" maxlength="250"
                           style="width: 100%"></b-input>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }"
                                   v-if="!contractor.hasUser"
                                   rules="phone|required|max:10">
                <b-field v-model="fields.phone"
                         label="Phone"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]">
                  <!-- todo: use ModernPhoneInput component -->
                  <b-input v-model="fields.phone" maxlength="10"
                           style="width: 100%"></b-input>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }"
                                   v-if="!contractor.hasUser"
                                   rules="email|required|max:250">
                <b-field v-model="fields.email"
                         label="E-mail"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]"
                         maxlength="250">
                  <b-input v-model="fields.email" maxlength="250"
                           style="width: 100%"></b-input>
                </b-field>
              </validation-provider>

              <validation-provider v-slot="{ errors }" rules="required">
                <b-field
                  :type="{ 'is-danger': errors.length }"
                  label="Type"
                  :message="errors + [ '&nbsp;' ]"
                >
                  <b-select v-model="fields.typeId" expanded>
                    <option
                      v-for="(type, index) in customerTypes"
                      :value="type.id"
                      :key="index"
                    >
                      {{ type.value }}
                    </option>
                  </b-select>
                </b-field>
              </validation-provider>

              <validation-provider v-slot="{ errors }"
                                   v-if="hasAccessToPlanModify && dataLoaded"
                                   rules="required">
                <b-field :type="{ 'is-danger': errors.length }"
                         label="Plan"
                         v-model="fields.plan"
                         :message="errors + [ '&nbsp;' ]">
                  <b-select-ext
                    class="custom-selector"
                    :selectedItem="fields.plan"
                    placeholder="Select a plan"
                    :options="modelPlans"
                    :autocomplete="true"
                    @input="partnerInput"
                  >
                  </b-select-ext>
                </b-field>
              </validation-provider>

              <div
                v-if="contractor.hasUser"
                class="multiple-users-box"
              >
                <div class="multiple-users-label-box">
                  <b-field>
                    <template slot="label">
                      Multiple Users
                      <b-tooltip
                        type="is-info"
                        class="is-gray"
                        :label="multipleUsersTooltip"
                        :size="windowWidth <= 760 ? 'is-small' : 'is-large'"
                        :position="windowWidth <= 760 ? 'is-bottom' : 'is-right'"
                        :delay="200"
                        :content-class="'pre-line'"
                        animated
                        multilined
                      >
                        <b-icon pack="fa" size="is-small" icon="question-circle" />
                      </b-tooltip>
                    </template>
                  </b-field>
                </div>

                <div class="multiple-users-fields">
                  <validation-provider v-slot="{ errors }">
                    <b-field v-model="fields.maxTeamUsersMode"
                             :type="{ 'is-danger': errors.length }"
                             :message="errors + [ '&nbsp;' ]"
                    >
                      <b-select v-model="fields.maxTeamUsersMode">
                        <option
                          v-for="(value, index) in maxTeamUsersModeOptions"
                          :value="value"
                          :key="index"
                        >
                          {{ value }}
                        </option>
                      </b-select>
                    </b-field>

                  </validation-provider>

                  <validation-provider v-slot="{ errors }">
                    <b-field v-model="fields.maxTeamUsers"
                             :type="{ 'is-danger': errors.length }"
                             :message="errors + [ '&nbsp;' ]">
                      <b-select
                        v-model="fields.maxTeamUsers"
                        :disabled="fields.maxTeamUsersMode === 'Auto'"
                        :class="{'disabled-select': fields.maxTeamUsersMode === 'Auto'}"
                      >
                        <option
                          v-for="(value, index) in maxTeamUsersOptions"
                          :value="value"
                          :key="index"
                        >
                          {{ value }}
                        </option>
                      </b-select>
                    </b-field>

                  </validation-provider>
                </div>
              </div>


              <validation-provider v-slot="{ errors }"
                                   rules="required">
                <b-field label="Payment Status"
                         v-model="fields.paymentStatus"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]">
                  <b-select v-model="fields.paymentStatus"
                            :expanded=true>
                    <option disabled value="">Select the option</option>
                    <option v-if="paidStatus" value="Paid">Paid</option>
                    <option v-if="paidStatus" value="Canceled">Canceled</option>
                    <option v-if="unpaidStatus" value="Unpaid">Unpaid</option>
                    <option v-if="unpaidStatus" value="Canceled">Canceled</option>
                    <option v-if="renewedStatus" value="Renewed">Renewed</option>
                    <option v-if="renewedStatus" value="Canceled">Canceled</option>
                    <option v-if="canceledStatus" value="Canceled">Canceled</option>
                    <option v-if="canceledStatus" value="Renewed">Renewed</option>
                    <option v-if="failedStatus" value="Failed">Failed</option>
                    <option v-if="failedStatus" value="Canceled">Canceled</option>
                  </b-select>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }"
                                   name="Partner ID"
                                   :rules="{onlyOne:fields.referralId, regex: /^\d+$/}"
              >
                <b-field v-model="fields.partnerId"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]"
                         label="Partner ID">
                  <b-input v-model="fields.partnerId"
                           style="width: 100%"></b-input>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }"
                                   name="Referral ID"
                                   :rules="{onlyOne:fields.partnerId, regex: /^\d+$/}"
              >
                <b-field v-model="fields.referralId"
                         :type="{ 'is-danger': errors.length }"
                         :message="errors + [ '&nbsp;' ]"
                         label="Referral ID">
                  <b-input v-model="fields.referralId"
                           style="width: 100%"></b-input>
                </b-field>
              </validation-provider>
            </form>
          </section>
          <footer class="modern-card__footer">
            <button type="button" class="button is-success outlined"
                    @click="cancel">Cancel</button>
            <button type="button" class="button is-success"
                    :disabled="!formChanged"
                    @click="handleSubmit(submit)">Update</button>
          </footer>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import { get, isEqual } from 'lodash';
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import { plan as getPlans } from '@/api/plan';
import { getMultipleUsers } from '@/api/settings';
import { teamMax, update } from '@/api/contractor';
import * as MUTATIONS from '@/store/mutations';
import BSelectExt from '@/components/BSelectExt.vue';
import MultipleUsersConfirmation from '@/components/Modal/MultipleUsersConfirmation.vue';
import { CUSTOMER_MAX_ALLOWED_MAX_TEAM_USERS } from '@/const/constants';

export default {
  components: {
    BSelectExt,
  },
  name: 'CustomerForm',
  props: ['contractor', 'active', 'customerTypes'],
  data() {
    const fields = {
      id: this.contractor.id,
      companyName: this.contractor.companyName,
      firstName: this.contractor.firstName,
      lastName: this.contractor.lastName,
      phone: this.contractor.phone,
      email: this.contractor.email,
      plan: this.contractor.plan,
      paymentStatus: this.contractor.paymentStatus,
      partnerId: this.contractor.partnerId ? this.contractor.partnerId : '',
      referralId: this.contractor.referralId ? this.contractor.referralId : '',
      maxTeamUsersMode: null,
      maxTeamUsers: null,
      teamUsersConfirmationReceived: false,
      typeId: this.contractor.type ? this.contractor.type.id : null,
    };

    return {
      initialFields: { ...fields },
      showListItems: false,
      fields: { ...fields },
      paidStatus: this.contractor.paymentStatus === 'Paid',
      unpaidStatus: this.contractor.paymentStatus === 'Unpaid',
      canceledStatus: this.contractor.paymentStatus === 'Canceled',
      renewedStatus: this.contractor.paymentStatus === 'Renewed',
      failedStatus: this.contractor.paymentStatus === 'Failed',
      PLAN_MODIFY: { resource: 'manage-contractors', code: 'plan_modify' },
      modelPlans: [],
      maxTeamUsersModeOptions: ['Auto', 'Manual'],
      maxTeamUsersOptions: [...Array(CUSTOMER_MAX_ALLOWED_MAX_TEAM_USERS + 1).keys()],
      maxTeamUsersByTier: null,
      confirmModal: null,
      multipleUsersTooltip: 'The maximum number of users a customer can grant access'
          + ' to their account. \nThe "Auto" mode allows adding the default number'
          + ' of "Multiple users" set for a tier plan under Settings [Manage]. \nThe "Manual"'
          + ' mode allows setting an individual number of users a customer can add. This number'
          + ' will not change if the plan or tier settings are changed.',
      multipleUsersSetting: null,
      dataLoaded: false,
    };
  },
  methods: {
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),

    partnerInput(val) {
      this.fields.plan = val;
    },
    getUpdatePayload() {
      const obj = {
        id: this.contractor.id,
        isManage: true,
      };

      const setIfNotEqual = (key) => {
        if (this.fields[key] !== this.contractor[key]) {
          obj[key] = this.fields[key];
        }
      };

      if (!this.contractor.hasUser) {
        setIfNotEqual('email');
        setIfNotEqual('companyName');
        setIfNotEqual('lastName');
        setIfNotEqual('firstName');
        setIfNotEqual('phone');
      }

      if (this.fields.referralId) {
        obj.referralId = this.fields.referralId;
      }

      if (this.fields.partnerId) {
        obj.partnerId = this.fields.partnerId;
      }

      if (this.hasAccessToPlanModify && this.fields.plan) {
        obj.plan = this.fields.plan.id;
      }

      if (this.contractor.hasUser) {
        if (this.fields.maxTeamUsers !== this.contractor.maxTeamUsers) {
          obj.maxTeamUsers = this.fields.maxTeamUsers;
        }

        if (this.contractor.maxTeamUsers !== null && this.fields.maxTeamUsersMode === 'Auto') {
          obj.maxTeamUsers = null;
        }
      }

      if (this.fields.teamUsersConfirmationReceived === true) {
        obj.teamUsersConfirmationReceived = this.fields.teamUsersConfirmationReceived;
      }

      obj.typeId = this.fields.typeId;
      obj.paymentStatus = this.fields.paymentStatus;

      return obj;
    },
    submit() {
      this.preloader(true);
      update(this.getUpdatePayload())
        .then((response) => {
          const error = get(response, 'data.error', null);
          const message = get(response, 'data.message', 'An unexpected error occurred, please contact support@enhancify.com');
          if (error) {
            this.$buefy.toast.open({ message, type: 'is-danger', duration: 3000 });
          } else if (response.data.teamUsersConfirmationRequired) {
            this.openConfirmModal();
          } else {
            this.active = false;
            this.$buefy.toast.open({ message: 'Field\'s was changed', type: 'is-success', duration: 3000 });
            this.$emit('submit', response.data);

            if (this.fields.teamUsersConfirmationReceived) {
              this.confirmModal.$off('close', this.onConfirmClose);
              this.confirmModal.close();
              this.confirmModal = null;
            }
          }
        })
        .catch((err) => {
          const isUIErrorMessage = get(err, 'response.data.is_ui_error_message', true);
          if (isUIErrorMessage) {
            const error = get(err, 'response.data.error', null);
            const message = get(err, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com');
            if (error) {
              this.$buefy.snackbar.open({
                message,
                position: 'is-top',
                indefinite: true,
                actionText: ' ',
                type: 'is-danger',
              });
            } else {
              this.$buefy.snackbar.open({
                message: 'An unexpected error occurred, please contact support@enhancify.com',
                position: 'is-top',
                indefinite: true,
                actionText: ' ',
                type: 'is-danger',
              });
            }
          }
        })
        .finally(() => this.preloader(false));
    },
    cancel() {
      this.active = false;
      this.$emit('close');
    },
    openConfirmModal() {
      const Component = Vue.extend(MultipleUsersConfirmation);
      this.confirmModal = this.$buefy.modal.open({
        parent: this,
        props: {
          contractors: [],
        },
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'multiple-users-confirmation card-form-modal',
        canCancel: ['outside'],
        events: {
          confirm: () => {
            this.fields.teamUsersConfirmationReceived = true;
            this.submit();
          },
          cancel: () => {
            this.confirmModal.close();
          },
        },
      });
      this.confirmModal.$on('close', this.onConfirmClose);
    },
    onConfirmClose() {
      if (this.confirmModal) {
        this.confirmModal.$off('close', this.onConfirmClose);
        this.confirmModal = null;
        this.fields.teamUsersConfirmationReceived = false;
      }
    },
    handleTeamMaxResponse(response) {
      if (response.status !== 200) {
        this.$buefy.snackbar.open({
          message: 'Something wrong',
          actionText: ' ',
          position: 'is-top',
          indefinite: true,
          type: 'is-danger',
        });
      }
      const { data } = response.data;
      const maxTeamUsersMode = data.contractorMaxTeamUsers === null ? 'Auto' : 'Manual';
      const maxTeamUsers = data.contractorMaxTeamUsers === null
        ? data.tierMaxTeamUsers
        : data.contractorMaxTeamUsers;

      this.maxTeamUsersByTier = data.tierMaxTeamUsers;

      this.initialFields.maxTeamUsersMode = maxTeamUsersMode;
      this.fields.maxTeamUsersMode = maxTeamUsersMode;

      this.initialFields.maxTeamUsers = maxTeamUsers;
      this.fields.maxTeamUsers = maxTeamUsers;
    },
  },
  computed: {
    ...mapGetters(['authAuthenticator']),
    formChanged() {
      const equals = Object.keys(this.fields).map((key) => {
        if (key === 'plan') {
          const oldPlan = this.contractor.plan ? this.contractor.plan.id : null;
          const newPlan = this.fields.plan ? this.fields.plan.id : null;
          return isEqual(oldPlan, newPlan);
        }
        return isEqual(this.fields[key], this.initialFields[key]);
      });
      return equals.includes(false);
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    hasAccessToPlanModify() {
      return this.authAuthenticator(this.PLAN_MODIFY);
    },
  },
  watch: {
    'fields.maxTeamUsersMode': function maxTeamUsersModeWatcher(newValue) {
      if (newValue === 'Auto') {
        this.fields.maxTeamUsers = this.maxTeamUsersByTier;
      }
    },
    'fields.plan': function planWatcher(newValue) {
      if (!this.multipleUsersSetting) {
        return;
      }
      const newPlan = this.modelPlans.find((plan) => plan.id === newValue.id);
      if (!Object.prototype.hasOwnProperty.call(this.multipleUsersSetting, newPlan.tier)) {
        throw new Error('Unexpected plan tier');
      }
      const maxTeamUsersByTier = this.multipleUsersSetting[newPlan.tier];
      this.maxTeamUsersByTier = maxTeamUsersByTier;
      if (this.fields.maxTeamUsersMode === 'Auto') {
        this.fields.maxTeamUsers = maxTeamUsersByTier;
      }
    },
  },
  async mounted() {
    this.preloader(true);

    const promises = [this.hasAccessToPlanModify ? getPlans({}) : null];
    if (this.contractor.hasUser) {
      promises.push(teamMax(this.contractor.id));
      promises.push(getMultipleUsers());
    }
    const [plansResponse, teamMaxResponse, multipleUsersResponse] = await Promise.all(promises);

    if (this.hasAccessToPlanModify) {
      this.modelPlans = plansResponse.data.data;
      this.modelPlans.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
    }

    if (this.contractor.hasUser) {
      this.handleTeamMaxResponse(teamMaxResponse);
      this.multipleUsersSetting = JSON.parse(multipleUsersResponse.data.data.paramVal);
    }

    this.dataLoaded = true;
    this.preloader(false);
  },
};
</script>

<style scoped lang="stylus">
.custom-selector >>> span.select.input
  height 48px
  font-size 19px
  font-weight 400
  color: #363636
  border 1px solid #8fa7b3
.dialog .modal-card .modal-card-body .field
  margin-top 0px

.dialog .modal-card
  padding 10px
  @media screen and (min-width: 600px)
    min-width 600px

.multiple-users-label-box
  margin-bottom 0.5em
.multiple-users-fields
  width 100%
  display flex
  > span:not(:last-child)
    margin-right 1em
  .disabled-select
    >>> span.select
      &:after
        border-color #BDBDBD !important
  span
    width 30%
    @media(max-width:760px)
      width 50%
    >>> .field
      width 100%
      .select,
      select
        width 100%
      select[disabled]
        color #BDBDBD
        border solid 1px #8FA7B34D
        background-color #EDEDED

span.b-tooltip[content-class="pre-line"]::after
  white-space pre-line

span.b-tooltip::after
  text-align left
</style>
